import classnames from 'classnames';
import styles from './index.module.scss';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { courseDetail } from '@/apis/course';
import { useEffect, useState } from 'react';
import { Collapse, Tooltip } from 'antd';

const CourseDetail = () => {
	let [searchParams] = useSearchParams();
	const courseUuid = searchParams.get('id');
	const [detail, setDetail] = useState({})
	const [course, setCourse] = useState([])
	const navigate = useNavigate()

	useEffect(() => {
		if (courseUuid) {
			getDetail()
		}
	}, [courseUuid])

	const getDetail = () => {
		courseDetail({
			courseUuid: courseUuid
		}).then(res => {
			const result = res?.data || {}
			setDetail({
				courseName: result?.courseName,
				teacherName: result?.teacherName,
				description: result?.description,
				coverImage: result?.coverImage?.filePath,
			})
			const arr = (result?.courseItems || []).map((item, index) => {
				return {
					key: 'item' + index,
					label: `第${index + 1}次课 【${item.subCourseName}】`,
					children: <div className={styles.collapseBox}>
						<div className={styles.titleBox}><span>开课时间</span>{item.startTime} 至 {item.endTime}</div>
						<div className={styles.titleBox}><span>相关资料</span></div>
						{item.courseMaterials.map((son, index2) => {
							return <div key={index + son.resourceUuid} className={styles.listBox}>
								<div><span>描述：</span>{son.materialDescription}</div>
								<div><span>资源：</span>
									<Tooltip title="点击查看资源详情">
										<a onClick={() => goDetail(son.resourceUuid)}>{son.resourceTitle}</a>
									</Tooltip>
								</div>
							</div>
						})}
					</div>
				}
			})
			setCourse(arr)
		})
	}

	const goDetail = (id) => {
		window.location.href = `${process.env.PUBLIC_URL}/discover/detail?id=${id}`
		// navigate(`${process.env.PUBLIC_URL}/discover/detail?id=${id}`,{relative: 'path'});
		window.scrollTo(0, 0)
	}

	return <div className={classnames('container', styles.courseDetailBox)}>
		<h2>{detail.courseName}</h2>
		<p>{detail.teacherName}</p>
		<div className={styles.imgBox}>
			{detail.coverImage && <img src={process.env.REACT_APP_API_AFFIX+"/file/preview?filePath=" + detail.coverImage} />}
		</div>
		<h3>课程简介</h3>
		<div className={styles.desc}>{detail.description}</div>
		<h3>课程安排</h3>
		<Collapse items={course} />
	</div>;
}
export default CourseDetail;